if( document.getElementById("btn-old-password-toggle") ) {
    document.getElementById("btn-old-password-toggle").addEventListener("click", function () {
        const input = document.getElementById("current-password");
        const icon = document.getElementById("old-password-icon");
        const toggleText = document.getElementById("old-password-text");

        const isPassword = input.type === "password";

        // Toggle input type
        input.type = isPassword ? "text" : "password";

        // Toggle text
        toggleText.textContent = isPassword ? "Hide Password" : "Show Password";

        // Toggle icon
        icon.innerHTML = isPassword
            ? `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0083fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>`
            : `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0083fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
                </svg>`;
    });
}

if( document.getElementById("btn-new-password-toggle") ) {
    document.getElementById("btn-new-password-toggle").addEventListener("click", function () {
        const input = document.getElementById("new-password");
        const icon = document.getElementById("new-password-icon");
        const toggleText = document.getElementById("new-password-text");

        const isPassword = input.type === "password";

        // Toggle input type
        input.type = isPassword ? "text" : "password";

        // Toggle text
        toggleText.textContent = isPassword ? "Hide Password" : "Show Password";

        // Toggle icon
        icon.innerHTML = isPassword
            ? `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0083fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>`
            : `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0083fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
                </svg>`;
    });
}

if( document.getElementById("btn-confirm-password-toggle") ) {
    document.getElementById("btn-confirm-password-toggle").addEventListener("click", function () {
        const input = document.getElementById("confirm-password");
        const icon = document.getElementById("confirm-password-icon");
        const toggleText = document.getElementById("confirm-password-text");

        const isPassword = input.type === "password";

        // Toggle input type
        input.type = isPassword ? "text" : "password";

        // Toggle text
        toggleText.textContent = isPassword ? "Hide Password" : "Show Password";

        // Toggle icon
        icon.innerHTML = isPassword
            ? `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0083fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye-off">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
                </svg>`
            : `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#0083fd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-eye">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
                </svg>`;
    });
}